import {EventEmitter, Injectable} from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";

export interface FieldError {
    path: string;
    message: string;
}

@Injectable({providedIn: 'root'})
export class ErrorHandlerService {

    //provide i18n mapping from exception context
    private globalErrorLookupTable: {[key: string]: string} = {
        "Bad credentials": "ERROR.BAD_CREDENTIALS"
    }

    fieldError: EventEmitter<FieldError> = new EventEmitter();
    clearFieldErrors: EventEmitter<any> = new EventEmitter();
    globalError: EventEmitter<any> = new EventEmitter();

    //FIXME: rethink whole system aproach of how error should be handled. do proper typings and strategy how responses should be handled if they contain errors.
    async handleError(errorResponse: HttpErrorResponse): Promise<void> {
        const error: HttpErrorResponse['error'] = errorResponse.error;

        if(errorResponse.status < 400) return; //TODO: remove me when real strategies are implemented

        if (error.errors) {
            this.handleValidationError(error);
        } else if (error instanceof Blob) {
            const blob = await error.arrayBuffer();
            const decodedError = JSON.parse(new TextDecoder("utf-8").decode(blob));
            this.globalError.emit(decodedError);
        } else {
            const mappedGlobalError = this.mapGlobalError(error);
            this.globalError.emit(mappedGlobalError);
        }
    }

    clearErrors(): void {
        this.clearFieldErrors.emit(null);
    }

    private handleValidationError(error: HttpErrorResponse['error']): void {
        this.clearErrors();
        error.errors.forEach((e: any) => {
            this.fieldError.emit({
                path: e.path,
                message: e.message || e.defaultMessage
            });
        });
    }

    private mapGlobalError(error: any){
        return {
            ...error,
            exception: this.globalErrorLookupTable[error.exception] ?? error.exception
        }
    }

}
